import { ethers } from 'ethers'
import { AERO_ROUTER } from '../addresses'
import { AERO_ROUTER_ABI } from '../abi'
import { aeroRoutes } from '../path'
import type { Adapter, ExecuteArgs } from './types'
import type { RouteCandidate } from '../types'

/**
 * Aerodrome v2 — volatile and stable pools, one or two hops.
 *
 * Every send uses the `SupportingFeeOnTransferTokens` variant, for every
 * token and not only MPRO. They are correct for an ordinary ERC-20 as well as
 * one that burns part of a transfer, they cost a little more gas, and one code
 * path that is always right is worth more than two that are each right half
 * the time.
 */
const iface = new ethers.utils.Interface(AERO_ROUTER_ABI as unknown as string[])

export const aeroV2Adapter: Adapter = {
  spender(args: ExecuteArgs): string | null {
    return args.tokenIn.isNative ? null : AERO_ROUTER
  },

  async buildTx(args: ExecuteArgs): Promise<ethers.PopulatedTransaction> {
    const candidate = args.quote.candidate as RouteCandidate
    const routes = aeroRoutes(candidate)
    const amountIn = ethers.BigNumber.from(args.quote.amountIn.toString())
    const minOut = ethers.BigNumber.from(args.minOut.toString())
    const deadline = ethers.BigNumber.from(args.deadline.toString())

    if (args.tokenIn.isNative) {
      return {
        to: AERO_ROUTER,
        data: iface.encodeFunctionData('swapExactETHForTokensSupportingFeeOnTransferTokens', [
          minOut,
          routes,
          args.account,
          deadline
        ]),
        value: amountIn
      }
    }

    if (args.tokenOut.isNative) {
      return {
        to: AERO_ROUTER,
        data: iface.encodeFunctionData('swapExactTokensForETHSupportingFeeOnTransferTokens', [
          amountIn,
          minOut,
          routes,
          args.account,
          deadline
        ]),
        value: ethers.constants.Zero
      }
    }

    return {
      to: AERO_ROUTER,
      data: iface.encodeFunctionData('swapExactTokensForTokensSupportingFeeOnTransferTokens', [
        amountIn,
        minOut,
        routes,
        args.account,
        deadline
      ]),
      value: ethers.constants.Zero
    }
  }
}
